import React, { memo, useContext, useEffect, useState } from 'react';
import "./index.css";
import SectionTitle from '../SectionTitle';
import CustomCheckBox from '../../../../components/CustomFormTag/checkbox';
import GuestCard from './components/GuestCard';
import { filterDataContext } from '../../../../App';

const GuestDetail = ({ values, errors, eventRequirements, handlePreCheckout, setFieldValue, setErrorEvent, setFieldError, openErrorEvent, checkForCheckoutPage, fieldRefs }) => {
    const { bookingData, setBookingData } = useContext(filterDataContext)
    const [checkForPreCheckoutRequired, setCheckForPreCheckoutRequired] = useState(false)

    useEffect(() => {
        if (!eventRequirements) return;
        const hasPreCheckout = eventRequirements?.some(item =>
            Object.values(item).flat().includes("pre_checkout")
        );
        setCheckForPreCheckoutRequired(hasPreCheckout)
    }, [eventRequirements]);

    useEffect(() => {
        setBookingData(values)
    }, [values])

    return (
        <SectionTitle
            msg={"Guest information"}
            subMsg={"For some events we require some information from your client to complete the bookings for you."}
        >
            {/* {
                !checkForPreCheckoutRequired &&
                <CustomCheckBox
                    text={"I'll add guest info later"}
                    value={values?.filGuestLater}
                    setValue={setFieldValue}
                    name={"filGuestLater"}
                />
            } */}
            <div className='checkout_guestDetails'>
                {values?.filGuestLater ? (
                    <div className='do_later_guest'>
                        <h3>
                            After completing this booking, complete guest details as soon as possible by going to your Bookings in our portal.
                        </h3>
                    </div>
                ) : (
                    values?.BookingData?.map(({ eventName, tickets, eventRequirements }, index) => (
                        <GuestCard
                            key={index}
                            eventName={eventName}
                            tickets={tickets}
                            errors={errors}
                            eventIndex={index}
                            values={values}
                            setFieldValue={setFieldValue}
                            eventRequirements={eventRequirements}
                            eventId={tickets?.[0]?.ticket?.event_id}
                            setFieldError={setFieldError}
                            checkForCheckoutPage={checkForCheckoutPage}
                            fieldRefs={fieldRefs}
                            openErrorEvent={openErrorEvent}
                            setErrorEvent={setErrorEvent}
                            handlePreCheckout={handlePreCheckout}
                        />
                    ))
                )}
            </div>
        </SectionTitle>
    );
};

export default memo(GuestDetail); 